import { useEffect, useState } from 'react';
import { DL_QUERY_STRINGS } from '../../../constants/dealerLocator.constants';
import { TState } from '../types/dealerLocatorLanding.types';
import { windowService } from '../../../utils/window.utils.js';

const useRegion = (defaultValue, country): [TState | null, React.Dispatch<React.SetStateAction<TState | null>>] => {
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const query = getQuery(DL_QUERY_STRINGS.REGION);
  const regionFromQuery = country?.states?.find((state) => state.gmiCode === query) ?? null;
  const [region, setRegion] = useState<TState | null>(regionFromQuery || defaultValue);
  const [regionGmiCode, setRegionGmiCode] = useState<string>('');

  useEffect(() => {
    if (!query || !regionFromQuery || query === regionGmiCode) {
      return;
    }

    setRegion(regionFromQuery);
  }, [query, regionFromQuery, country]);

  useEffect(() => {
    setRegionGmiCode(region?.gmiCode ?? '');
  }, [region]);

  return [region, setRegion];
};

export default useRegion;
